import { Link, useNavigate, useLocation } from 'react-router-dom';
import { getUserInfo, removeCookie } from '../../common/cookie';
import { useEffect, useState } from 'react';

const Header = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const [isAdmin, setIsAdmin] = useState(false);
    const [userInfo, setUserInfo] = useState({});
    
    const handleLogout = () => {
        // localStorage와 쿠키에서 토큰 삭제
        localStorage.removeItem('token');
        removeCookie('token');
        navigate('/login');
    }

    useEffect(() => {
        const userInfo = getUserInfo();
		console.log(userInfo, 'userInfo');
        setUserInfo(userInfo);
        if (userInfo) setIsAdmin(userInfo.isAdmin);
    }, []);

    return (
        <aside className="vh-header-wrap">
			<div className="logo">
				<img src="/static/img/logo/logo_40_30.png" alt="logo" />
			</div>
			<ul className="header-nav-menu">
				<li className={location.pathname === '/notice' ? 'active' : ''}>
					<Link to="/notice"><span>공지사항</span></Link>
				</li>
				<li className={location.pathname === '/slots' ? 'active' : ''}>
					<Link to="/slots"><span>광고관리</span></Link>
				</li>
				{isAdmin && (
					<>
						<li className={location.pathname === '/users' ? 'active' : ''}>
							<Link to="/users"><span>계정관리</span></Link>
						</li>
						<li className={location.pathname === '/logs' ? 'active' : ''}>
							<Link to="/logs"><span>로그관리</span></Link>
						</li>
					</>
				)}
			</ul>
			<div className="nav-bottom">
				<div className="nav-profile">
					<div className="nav-profile-thumb">1</div>
					<div>
						<span>회사명</span>
						<p>{userInfo.userOrg}</p>
					</div>
				</div>
				<div className="nav-signout">
					<a onClick={handleLogout}>로그아웃</a>
				</div>
			</div>
		</aside>
    )
}

export default Header;